/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

import { toast } from 'react-toastify';

import { LoadingSpinner } from '../../loadingSpinner/loadingspinner';
import { useGetUserByIDQuery, useGetUserByNameQuery } from '../../scoreCardFilter/scoreCardFilterSlice';

import { selectCurrentEmpid, selectCurrentIsAdmin, selectCurrentIsHC, selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import { ROLES } from '../../../constants';
import './employeeFilter.scss';

type Employee = {
    name: string;
    id: string;
    supId: string;
}[];

type associateLookupProps = {
    setAgentNumber?: React.Dispatch<any>;
    setAgentName?: (e: any) => void;
    resetDate: () => void;
};

export const EmployeeFilter = ({ setAgentNumber, setAgentName, resetDate }: associateLookupProps) => {
    const [inputNameOrID, setInputNameOrID] = useState<number | string>('');
    const [associateOracleId, setAssociateOracleId] = useState<string>('');
    const [selectedID, setSelectedId] = useState<string>('');
    const [associateName, setAssociateName] = useState<string>('');
    const [listOfUsers, setListOfUsers] = useState<Employee>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isHC = useSelector(selectCurrentIsHC);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const {
        data: associateIdData,
        isFetching: associateIdFetching,
        isSuccess: idFound,
    } = useGetUserByIDQuery(
        {
            filterParam: associateOracleId,
            searcherEmpNo: loggedEmpNum,
            getAllEmps: (isAdmin || isHC || ROLES.Manager.includes(userManagerLevel)) && true ,
        },
        { skip: !associateOracleId || !loggedEmpNum }
    );
    const {
        data: associateNameData,
        isFetching: associateNameFetching,
        isSuccess: nameFound,
    } = useGetUserByNameQuery(
        {
            filterParam: associateName,
            searcherEmpNo: loggedEmpNum,
            getAllEmps: (isAdmin || isHC || ROLES.Manager.includes(userManagerLevel)) && true ,
        },
        { skip: !associateName || !loggedEmpNum }
    );

    const resetAllFilters = () => {
        setAssociateOracleId('');
        setAssociateName('');
        if (setAgentName) {
            setAgentName('');
        }
        setListOfUsers([]);
        setInputNameOrID('');
        setSelectedId('')
        resetDate();
    };

    const submitSelectedUser = (e:any) => {
        const selectedUserID = e?.value;
        if (selectedUserID !== null && selectedUserID !== '') {
            setSelectedId(selectedUserID);
            setSelectedUser(selectedUserID);
        } else if (selectedUserID === null && listOfUsers.length > 0) {
            toast.error(`no selection id  ${listOfUsers[0].id}, name, ${listOfUsers[0].name}`);
            setValidationAgentName(listOfUsers[0]?.name);
        } else {
            toast.error('No user selected');
        }
    };

    const setSelectedUser = (selectedUserID: string) => {
        try {
            const pickedAgent = listOfUsers?.filter((user) => {
                if (user.id !== '') return user.id.toString() === selectedUserID.toString();
                else throw new Error('error');
            });
            if (pickedAgent.length > 0) {
                setValidationAgentName(pickedAgent[0]?.name);
            }
        } catch (err: any) {
            toast.error('No user selected');
        }
    };

    const setValidationAgentName = (agentName: string) => {
        if (setAgentName) setAgentName(agentName);
    };

    useEffect(() => {
        if (idFound && associateIdData?.data.length > 0) {
            const arrayOfUsers: Employee = associateIdData?.data.map((item: any) => ({
                name: item?.last_name.concat(' ', item?.first_name, ' (', item?.employee_number, ')'),
                id: item?.employee_number,
                supId: item?.supervisor_number,
            }));
            setListOfUsers(arrayOfUsers);
        }
        else
            setListOfUsers([]);
    }, [associateOracleId, idFound, associateIdData]);

    useEffect(() => {
        if (associateNameData?.data.length > 0) {
            const arrayOfUsers: Employee = associateNameData?.data.map((item: any) => ({
                name: item?.first_name.concat(' ', item?.last_name, ' (', item?.employee_number, ')'),
                id: item?.employee_number,
                supId: item?.supervisor_number,
            }));
            setListOfUsers(arrayOfUsers);
        }
        else
            setListOfUsers([]);
    }, [associateName, nameFound]);

    useEffect(() => {
        if (setAgentNumber) {
            setAgentNumber(selectedID);
        }
    }, [selectedID]);

    useEffect(() => {
        if (associateIdFetching || associateNameFetching) {
            setLoading(true);
        } else setLoading(false);
    }, [associateIdFetching, associateNameFetching]);

    useEffect(() => {
        let recEmpNo =
            localStorage.getItem('recEmpNo') !== null
                ? JSON.parse(localStorage.getItem('recEmpNo') || '0')
                : '';
        if (recEmpNo === '0' || recEmpNo === '' || recEmpNo === null) {
            recEmpNo = '';
        } else {
            setInputNameOrID(parseInt(recEmpNo, 10));
            setAssociateOracleId(recEmpNo);
        }
    }, []);
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            setInputNameOrID(value);
    
            if (!value || value.trim().length === 0) {
                setAssociateOracleId('');
                setAssociateName('');
                setListOfUsers([]);
                return;
            }
    
            if (/^\d+$/.test(value)) {
                if (value.length >= 7) {
                    setAssociateOracleId(value);
                    setAssociateName('');
                } else {
                    setAssociateOracleId('');
                    setListOfUsers([]);
                }
            } else if (value.trim().length >= 3) {
                setAssociateName(value);
                setAssociateOracleId('');
            } else {
                setAssociateName('');
                setListOfUsers([]);
            }
    
            setSelectedId('');
        };
    return (
        <>
                    <div id="EmployeeFilter"
                        className="d-flex flex-wrap align-items-center justify-content-between p-4"
                        style={{ marginTop: '1rem', gap: '1rem' }}
                    >
                        <div className="d-flex flex-wrap align-items-center gap-3">
                            <div style={{ width: '280px' }}>
                                <h6>Associate Name or Oracle ID</h6>
                                <InputText
                                    style={{ borderRadius: '25px', width: '100%' }}
                                    placeholder="Search by Name or Oracle ID"
                                    value={inputNameOrID}
                                    onChange={handleInputChange}
                                />
                            </div>
        
                            <div style={{ width: '280px' }}>
                                <h6>Select User</h6>
                                <Dropdown
                                    id="EmployeeFilterDropdown"
                                    value={selectedID}
                                    options={listOfUsers}
                                    optionLabel="name"
                                    optionValue="id"
                                    placeholder="Select User"
                                    style={{ width: '100%',borderRadius: '25px' }}
                                    onChange={submitSelectedUser}
                                />
                            </div>
                        </div>
        
                        <div>
                            <Button
                                type="button"
                                label="Reset" 
                                // style={{ fontWeight: 400, borderRadius: '10px',backgroundColor:'#FFFFFF' }}
                                className="btn-secondary mt-4 float-end"
                                onClick={resetAllFilters}
                            />
                        </div>
                    </div>
                    <span>{loading ? <LoadingSpinner /> : ''}</span>
                    <br />
                </>
    );
};
